export function mapSubprojects(item, items, key = 'subprojects'): void {
  const index = items.indexOf(item);
  const subprojects = item[key];
  if (subprojects && !items.includes(subprojects[0])) {
    items.splice(index + 1, 0, ...subprojects);
  }
}

export function includeSubprojects(newItemsLength, collectionItems = [], key = 'subprojects'): void {
  const length = collectionItems.length;
  for (let i = 0; i < newItemsLength; i++) {
    const minusIndex = length - i - 1;
    const item = collectionItems[minusIndex];
    mapSubprojects(item, collectionItems, key);
  }
}
